// extracted by mini-css-extract-plugin
export default {"header":"_3jT06t9v","brandedGreen":"_3ad7WrUy","brandedWhite":"_2yq_5-9X","logo":"_2t_HesEI"};